<script>
export default {
  components: {},
  props: {
    title: {
      type: String,
      required: false,
      default: '',
    },
    dialogClassName: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {
      classes: this.computeClassName(),
    }
  },
  computed: {},
  methods: {
    computeClassName: function() {
      const classes = {
        scrollable: false,
      }

      this.dialogClassName.split(' ').forEach((className) => {
        switch (className) {
          case 'modal-dialog-scrollable':
            classes.scrollable = true
        }
      })
      return classes
    },
    show: function() {
      this.$refs.modal.show()
    },
    hide: function() {
      this.$refs.modal.hide()
    },
    toggle: function() {
      this.$refs.modal.toggle()
    },
    handleOk: function() {},
    shown: function() {
      this.$emit('shown')
    },
    hidden() {
      this.$emit('hidden')
    },
  },
}
</script>

<template>
  <b-modal
    ref="modal"
    :dialog-class="dialogClassName"
    @shown="shown"
    @hidden="hidden"
  >
    <template v-slot:modal-header>
      <h5 class="modal-title font-18">{{ title }}</h5>
      <button type="button" class="close" @click="hide">
        <span aria-hidden="true">&times;</span>
      </button>
    </template>

    <slot></slot>

    <template v-slot:modal-footer>
      <slot name="buttons"></slot>
      <button type="button" class="btn btn-secondary" @click="hide"
        >닫기</button
      >
    </template>
  </b-modal>
</template>
